import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GradeService } from 'src/app/school-management/_services/grades.service';
import { DashboardService } from '../_services/dashboard.service';
import * as moment from 'moment';
import * as XLSX from 'xlsx';
import * as FILESAVER from 'file-saver';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { ReportsFilter } from '../_model/reports-filter.model';

declare var $: any;

@Component({
  selector: 'app-attendance-reports',
  templateUrl: './attendance-reports.component.html',
  styleUrls: ['./attendance-reports.component.scss']
})
export class AttendanceReportsComponent implements OnInit, OnDestroy {
  loading = true;
  filterStatus = false;
  daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
  controlType = "attendance-week";
  reportType = 'week';
  reportFilter;
  filterValues;
  filteredGrades:any[]=[];
  filteredClasses:any[]=[];
  reportToDate;
  tableControls: any = { data: [] };
  dataArray = [];
  listType='attendance-reports'
  clonedDataArray = [];
  classStudents;
  teacherName;
  totalPresentCount = 0;
  attendancePercentage = 0;
  filterSub;
  printSub;
  typeSub;
  modalData;
  student_id;
  modalOpen = false;
  reportFlag = false;
  currLang;
  from: number;
  to: number;
  total: number;
  nextPage: number;
  prevPage: number;
  currentPage: number;
  lastPage: number;
  exportAttendanceFilter;
  constructor(
    private router: Router,
    private dashboardService: DashboardService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private gradesService: GradeService) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.filterSub = new Subscription();
    this.printSub = new Subscription();
    this.typeSub = new Subscription();
  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    $(document).on('hidden.bs.modal', '#studentAttendanceReport', () => {
      // this.loading = true;
      delete this.reportFilter.search;
    })
    this.currentPage = 1;
    this.dashboardService.setFilterValue(new ReportsFilter());
    let t = this.dashboardService.getReportType().subscribe((res: any) => {
      this.currentPage = 1;
      if (res !== null) {
        this.loading = true;
        this.reportType = res;
        this.attendancePercentage = 0;
        this.totalPresentCount = 0;
        this.controlType = this.reportType === 'week' ? 'attendance-week' : 'attendance-day';
        let x = this.dashboardService.getReportFilter().subscribe((res: any) => {
          if (res !== null) {
            this.loading = true;
            this.modalOpen = $('#studentAttendanceReport').hasClass('show') ? true : false;
            this.reportFilter = res;
            this.reportToDate=this.reportFilter.toDate

            if (this.reportFilter.search === undefined || this.reportFilter.search === '') {
              this.attendancePercentage = 0;
            }
            this.totalPresentCount = 0;
            this.setTableDate();
            if (this.modalOpen) {
              this.reportFilter.search = this.student_id;
              let reportFilterCopy = { ...this.reportFilter };
              reportFilterCopy.search = this.student_id;
              reportFilterCopy.grade = undefined;
              reportFilterCopy.clazz = undefined;
              this.dashboardService.getAttendaceStudentsReport(reportFilterCopy, 'day',1).subscribe((res: any) => {
                this.dashboardService.setModalData(res.data[0]);
              })
            }
            setTimeout(() => {
              this.loading = false;
            }, 1500);
          }
        })
        this.filterSub.add(x);
      }
    })
    this.typeSub.add(t)

    // test 
     this.dashboardService.getFilterValue().subscribe((res: any) => {
      this.filterValues=res;
       this.setTableDate();
    })
    let p = this.dashboardService.getDownloadData().subscribe((res: any) => {
      if (res && this.router.url.split('/')[2] === 'attendance-reports' && !this.modalOpen) {
        let workBook = XLSX.utils.book_new();
        workBook.SheetNames.push('test sheet');
        let valuesToBeExported = [];
        this.dataArray.map(data => {
          valuesToBeExported.push(data)
        })

        let ws_Data = valuesToBeExported;
        let ws = XLSX.utils.json_to_sheet(ws_Data);
        workBook.Sheets['test sheet'] = ws;
        let workBookOut = XLSX.writeFile(workBook, 'book.xlsx');

        function s2ab(s) {
          let buf = new ArrayBuffer(s.length);
          let view = new Uint8Array(buf);
          for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
          return buf;
        }
        $("#button-a").click(function () {
          FILESAVER.saveAs(new Blob([s2ab(workBookOut)], { type: "application/octet-stream" }), 'test.xlsx');
        });
      }
    })
    this.printSub.add(p);
  }

  setTableDate() {
    this.loading = true;
    this.from =this.to =this.total = this.lastPage = 0;
    if (this.reportFilter !== undefined) {
      let tempFilter = { ...this.reportFilter , ...this.filterValues };
      this.exportAttendanceFilter = tempFilter
      this.dashboardService.getAttendaceStudentsReport(tempFilter, this.reportType , this.currentPage).subscribe((res: any) => {
        this.from = res.from;
        this.to = res.to;
        this.total = res.total;
        this.lastPage = res.last_page;
        this.dataArray = [];
        if (this.reportType === 'week') {
          res.data.forEach(element => {

            let temp = {};
            element.attendance.map(day => {
              if (this.daysOfWeek.includes(day.date.slice(0, 3))) {
                temp[day.date.slice(0, 3)] = day;
              }
            })

            this.dataArray.push({
              id: element.id,
              national_id: element.national_id,
              student_image: element.image_path,
              name: element.name,
              // Sun: temp['Sun']?.status.name === "present" || temp['Sun']?.status.name === "late" ? 1 : 0,
              // Mon: temp['Mon']?.status.name === "present" || temp['Mon']?.status.name === "late" ? 1 : 0,
              // Tue: temp['Tue']?.status.name === "present" || temp['Tue']?.status.name === "late" ? 1 : 0,
              // Wed: temp['Wed']?.status.name === "present" || temp['Wed']?.status.name === "late" ? 1 : 0,
              // Thu: temp['Thu']?.status.name === "present" || temp['Thu']?.status.name === "late" ? 1 : 0
              Sun: temp['Sun']?.status.name === undefined ? -1 :temp['Sun']?.status.name === "present" ? 1 :temp['Sun']?.status.name === "late"? 2:0,
              Mon: temp['Mon']?.status.name === undefined ? -1 :temp['Mon']?.status.name === "present" ? 1 :temp['Mon']?.status.name === "late"? 2:0,
              Tue: temp['Tue']?.status.name === undefined ? -1 :temp['Tue']?.status.name === "present" ? 1 :temp['Tue']?.status.name === "late"? 2:0,
              Wed: temp['Wed']?.status.name === undefined ? -1 :temp['Wed']?.status.name === "present" ? 1 :temp['Wed']?.status.name === "late"? 2:0,
              Thu: temp['Thu']?.status.name === undefined ? -1 :temp['Thu']?.status.name === "present" ? 1 :temp['Thu']?.status.name === "late"? 2:0,
              // Sun: temp['Sun']?.status.name === undefined ? -1 :temp['Sun']?.status.name === "present" || temp['Sun']?.status.name === "late" ? 1 : 0,
              // Mon: temp['Mon']?.status.name === undefined ? -1 :temp['Mon']?.status.name === "present" || temp['Mon']?.status.name === "late" ? 1 : 0,
              // Tue: temp['Tue']?.status.name === undefined ? -1 :temp['Tue']?.status.name === "present" || temp['Tue']?.status.name === "late" ? 1 : 0,
              // Wed: temp['Wed']?.status.name === undefined ? -1 :temp['Wed']?.status.name === "present" || temp['Wed']?.status.name === "late" ? 1 : 0,
              // Thu: temp['Thu']?.status.name === undefined ? -1 :temp['Thu']?.status.name === "present" || temp['Thu']?.status.name === "late" ? 1 : 0
            })

            // else{
            //   this.dataArray.push({
            //     id: element.id,
            //     national_id: element.national_id,
            //     student_image: element.image_path,
            //     name: element.name,
            //     Sun: temp['Sun']?.status.name === "present" ? 1 : 0,
            //     Mon: temp['Mon']?.status.name === "present" ? 1 : 0,
            //     Tue: temp['Tue']?.status.name === "present" ? 1 : 0,
            //     Wed: temp['Wed']?.status.name === "present" ? 1 : 0,
            //     Thu: temp['Thu']?.status.name === "present" ? 1 : 0
            //   })
            // }
          });
          // first table
          this.translate.get('init').subscribe(res => {
            this.setWeekTableControls();
          });
          this.translate.onLangChange.subscribe(res => {
            this.dashboardService.setFilterValue([])
            this.setWeekTableControls();
          });
        }

        else {
          let rangeOfDays = 1;
          res.data.map(att => {
            rangeOfDays = att.attendance.length >= rangeOfDays ? att.attendance.length : rangeOfDays
          })
          if (this.reportFilter.fromDate === this.reportFilter.toDate) {
            // the user selected one day only ... show the single table
            res.data.forEach(element => {
              this.totalPresentCount = this.totalPresentCount + element.attendance_present_count;

              this.dataArray.push({
                id: element.id,
                national_id: element.national_id,
                student_image: element.image_path,
                name: element.name,
                present: element.attendance[0]?.status.name === 'present'? true: element.attendance[0]?.status.name === 'late' ? false :null,
                absent: element.attendance[0]?.status.name === 'absent' ? true : null
              })
            });
            // report type is days
            // second table
            this.translate.get('init').subscribe(res => {
              this.setDaysTableControls();
            });
            this.translate.onLangChange.subscribe(res => {
              this.setDaysTableControls();
            });
          }
          else {
            // the user selected range of days ... show count table
            res.data.forEach(element => {
              this.totalPresentCount = this.totalPresentCount + element.attendance_present_count;
              this.dataArray.push({
                id: element.id,
                national_id: element.national_id,
                student_image: element.image_path,
                name: element.name,
                // element.attendance
                present_count: element.attendance_present_count,
                absent_count: element.attendance_absent_count
              })
            });
            // third table
            this.translate.get('init').subscribe(res => {
              this.setCountTableControls();
            });
            this.translate.onLangChange.subscribe(res => {
              this.setCountTableControls();
            });
          }
          if (this.reportFilter.search === undefined || this.reportFilter.search === '') {
            this.gradesService.getSingleClass(this.reportFilter.clazz.id).subscribe((res: any) => {
              this.classStudents = res.students.length;
              this.teacherName = res.teachers[0].name;
              this.attendancePercentage = this.classStudents !== 0 ?
                (Math.floor(((this.totalPresentCount / 2) / this.classStudents) * 100)) / rangeOfDays : 0;
            })
          }
        }
        
      })
      this.stopLoading();
    }
    this.dashboardService.getFilterStatus().subscribe((res: any) => {
      this.filterStatus = res;
    })
  }
  setWeekTableControls() {
    this.tableControls = {
      selection: false,
      paging: true,
      view: 'list',
      pagination: {
        from: this.from,
        to: this.to,
        total: this.total
      },
      columns: [
        {
          name: "",
          sort: false,
          type: "image",
          source: "student_image"
        },
        {
          name: this.translate.instant('student-attendance.student-name'),
          sort: false,
          type: "string",
          source: "name"
        },
        {
          name: this.translate.instant('student-attendance.student-id'),
          sort: false,
          type: "string",
          source: "national_id"
        },
        {
          name: this.translate.instant('student-attendance.sunday'),
          sort: false,
          type: "attendanceIcon",
          source: "Sun"
        },
        {
          name: this.translate.instant('student-attendance.monday'),
          sort: false,
          type: "attendanceIcon",
          source: "Mon"
        },
        {
          name: this.translate.instant('student-attendance.tuesday'),
          sort: false,
          type: "attendanceIcon",
          source: "Tue"
        },
        {
          name: this.translate.instant('student-attendance.wednesday'),
          sort: false,
          type: "attendanceIcon",
          source: "Wed"
        },
        {
          name: this.translate.instant('student-attendance.thursday'),
          sort: false,
          type: "attendanceIcon",
          source: "Thu"
        }
      ],
      data: this.dataArray
    }
  }
  setDaysTableControls() {
    this.tableControls = {
      selection: false,
      paging: true,
      view: 'list',
      pagination: {
        from: this.from,
        to: this.to,
        total: this.total
      },
      columns: [
        {
          name: "",
          sort: false,
          type: "image",
          source: "student_image"
        },
        {
          name: this.translate.instant('student-attendance.student-name'),
          sort: false,
          type: "string",
          source: "name"
        },
        {
          name: this.translate.instant('student-attendance.student-id'),
          sort: false,
          type: "string",
          source: "national_id"
        },
        {
          name: this.translate.instant('student-attendance.present'),
          sort: false,
          type: "showIcon",
          source: "present"
        },
        {
          name: this.translate.instant('student-attendance.absent'),
          sort: false,
          type: "falseIcon",
          source: "absent"
        }
      ],
      data: this.dataArray
    }
  }
  setCountTableControls() {
    this.tableControls = {
      selection: false,
      paging: true,
      view: 'list',
      pagination: {
        from: this.from,
        to: this.to,
        total: this.total
      },
      columns: [
        {
          name: "",
          sort: false,
          type: "image",
          source: "student_image"
        },
        {
          name: this.translate.instant('student-attendance.student-name'),
          sort: false,
          type: "string",
          source: "name"
        },
        {
          name: "",
          sort: false,
          type: "string",
          source: "grade_name"
        },
        {
          name: this.translate.instant('student-attendance.present'),
          sort: false,
          type: "string",
          source: "present_count"
        },
        {
          name: this.translate.instant('student-attendance.absent'),
          sort: false,
          type: "string",
          source: "absent_count"
        }
      ],
      data: this.dataArray
    }
  }
  ngOnDestroy(): void {
    this.filterSub.unsubscribe();
    this.printSub.unsubscribe();
    this.dashboardService.toggleFilterStatus(false);
  }

  back() {
    this.router.navigateByUrl('/reports/dashboard');
  }

  stopLoading() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
  tableEventHandeler(event) {
    switch (event.action) {
      case "rowClicked":
        this.rowClicked(event.target);
        break;
        case "pagination":
        this.paginationHandling(event.target);
        break;
    }
  }

  paginationHandling(event) {
    this.currentPage += event.dir;
    this.setTableDate();
  }
  rowClicked(event) {
    // this.reportFilter.toDate = moment(new Date()).format('YYYY-MM-DD');
    // this.reportFilter.fromDate = moment(new Date()).format('YYYY-MM-DD');
        this.reportFilter.toDate = this.reportFilter.toDate;
        this.reportFilter.fromDate = this.reportFilter.fromDate;
    
    this.dashboardService.setReportFilter(this.reportFilter)
    this.student_id = event.data.national_id
    this.reportFilter.search = event.data.national_id;

    this.dashboardService.getAttendaceStudentsReport(this.reportFilter, 'day',1).subscribe((res: any) => {
      
      this.dashboardService.setModalData(res.data[0])
      this.modalOpen = true;
      $("#studentAttendanceReport").modal("show")
    })
  }

  initSubtitle():any[]{
    let subTitle;
    if(this.filteredGrades.length !=0 || this.filteredClasses.length !=0){
       subTitle = [[[this.filteredGrades],[this.filteredClasses],this.reportFilter.fromDate,this.reportToDate]];
    }
    else {
      switch(this.currLang) {
        case "en":
          subTitle = [['All Grades In',this.reportFilter.fromDate,this.reportToDate]]
          break;
        case "ar":
          subTitle = [[this.reportFilter.fromDate,this.reportToDate,'جميع الصفوف بتاريخ']]
          break;
      }
    }
    return subTitle
  }
  
  generateExcelFile() {
    this.dashboardService.generateAttendanceExcelFile(this.exportAttendanceFilter,this.reportType).subscribe(res => {
    })
  }

  // exportToExcelFile() {  
  //   let valuesToBeExported = [];
  //   let Heading = [];
  //   let title = [];
  //   this.filteredGrades=[];
  //   this.filteredClasses=[];
  //   if(this.reportFilter.toDate=='Invalid date' || this.reportFilter.toDate === this.reportFilter.fromDate ){
  //     this.reportToDate =''
      
  //   }
  //   if(this.filterValues.grades){
  //     if(this.filterValues.grades.length>0){
  //       this.filterValues.grades.forEach(grade => {
  //         this.filteredGrades.push(grade.name);
  //       });
  //     }
  //     else{
  //       this.filteredGrades=[]
  //     }
  //   }
   
  //   if(this.filterValues.classes){
  //     if(this.filterValues.classes.length>0){
  //       this.filterValues.classes.forEach(clazz => {
  //         this.filteredClasses.push(clazz.name);
  //       });
  //     }
  //     else{
  //       this.filteredClasses=[]
  //     }
  //   }
  //   let fileName='';
  //   if(this.controlType==="attendance-week"){
  //     if (this.currLang === 'en') {
  //       this.clonedDataArray=[]
  //       Heading = [["Student Name", "Student ID", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"]]
  //       title = [[" Weekly Attendance report "]];
  //       fileName="Attendance.xlsx"
  //       this.dataArray.forEach(obj => {
  //         const { id, student_image, ...newObj } = obj;
  //         this.clonedDataArray.push({
  //           name:newObj.name, 
  //           national_id: newObj.national_id,
  //           // 1 represents Present , 2 represents late >> we consider both late and present to be present 
  //           sun: newObj.Sun == -1 ? "" : newObj.Sun == 1 || newObj.Sun == 2 ? 'Present' : 'Absent',
  //           mon: newObj.Mon == -1 ? "" : newObj.Mon == 1 || newObj.Mon == 2 ? 'Present' : 'Absent',
  //           tue: newObj.Tue == -1 ? "" : newObj.Tue == 1 || newObj.Tue == 2 ? 'Present' : 'Absent',
  //           wed: newObj.Wed == -1 ? "" : newObj.Wed == 1 || newObj.Wed == 2 ? 'Present' : 'Absent',
  //           thu: newObj.Thu == -1 ? "" : newObj.Thu == 1 || newObj.Thu == 2 ? 'Present' : 'Absent'
  //         })
  //       })
  
  //     }
  //     else {
  //       this.clonedDataArray=[]
  //       Heading = [["الخميس ", "الأربعاء", "الثلاثاء", "الإثنين", "الأحد", "هوية الطالب", "اسم الطالب"]]
  //       title = [[" تقرير الحضور الأسبوعى  "]];
  //       fileName="الحضور.xlsx"
  //       this.dataArray.forEach(obj => {
  //         const { id, student_image, ...newObj } = obj;
  //         this.clonedDataArray.push({
  //           thu: newObj.Thu == -1 ? "" : newObj.Thu == 1 || newObj.Thu == 2 ? 'حاضر' : 'غائب',
  //           wed: newObj.Wed == -1 ? "" : newObj.Wed == 1 || newObj.Wed == 2 ? 'حاضر' : 'غائب',
  //           tue: newObj.Tue == -1 ? "" : newObj.Tue == 1 || newObj.Tue == 2 ? 'حاضر' : 'غائب',
  //           mon: newObj.Mon == -1 ? "" : newObj.Mon == 1 || newObj.Mon == 2 ? 'حاضر' : 'غائب',
  //           sun: newObj.Sun == -1 ? "" : newObj.Sun == 1 || newObj.Sun == 2 ? 'حاضر' : 'غائب',
  //           national_id: newObj.national_id,
  //           name:newObj.name, 
  //         })
  //       })
  //     }
  //   }
  //   if(this.controlType==="attendance-day"){
  //     if (this.currLang === 'en') {
  //       this.clonedDataArray=[]
  //       Heading = [["Student Name", "Student ID", "Present", "Absent"]]
  //       title = [[" Daily Attendance report "]];
  //       fileName="Attendance.xlsx"
  //       this.dataArray.forEach(obj => {
  //         const { id, student_image, ...newObj } = obj;
  //         this.clonedDataArray.push({
  //           name:newObj.name, 
  //           national_id: newObj.national_id,
  //         // true represents Present , false represents late >> we consider both late and present to be present 
  //           present:newObj.present == true || newObj.present == false ? 'present' :obj.present_count,
  //           absent:newObj.absent  == true ?  'absent' :obj.absent_count
  //         })
  //       })
  
  //     }
  //     else {
  //       this.clonedDataArray=[]
  //       Heading = [["غائب", "حاضر", "هوية الطالب", "اسم الطالب"]]
  //       title = [[" تقرير الحضور اليومى "]];
  //       fileName="الحضور.xlsx"
  //       this.dataArray.forEach(obj => {
  //         const { id, student_image, ...newObj } = obj;
  //         this.clonedDataArray.push({
  //           absent:newObj.absent == true ? 'غائب' :obj.absent_count,
  //           present:newObj.present == true || newObj.present == false? 'حاضر' : obj.present_count,
  //           national_id: newObj.national_id,
  //           name:newObj.name, 
  //         })
  //       })
  //     }
  //   }

  //   valuesToBeExported = this.clonedDataArray
  //   // declaring the workbook
  //   let workBook = XLSX.utils.book_new();
  //   // declaring the sheet 
  //   const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
  //   // add array of array to the sheet , for the title at column K and first row  
  //   XLSX.utils.sheet_add_aoa(ws, title, { origin: 'K1'});
  //   // add array of array to the sheet , for the subtitle at column J and second row
  //   XLSX.utils.sheet_add_aoa(ws, this.initSubtitle(), { origin: 'J2'}); 
  //   // add array of array to the sheet , for the table headings at column A and third row
  //   XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A3'});
  //   // add the json data to the sheet at column A and forth row and skipping headers(object keys) to avoid overriding 
  //   XLSX.utils.sheet_add_json(ws, valuesToBeExported, { origin: 'A4', skipHeader: true });
  //  //adding the sheet to the workbook
  //   XLSX.utils.book_append_sheet(workBook, ws, 'Sheet1');
  //   // writting the book and renaming it 
  //   let workBookOut = XLSX.writeFile(workBook, fileName);

  //   function s2ab(s) {
  //     let buf = new ArrayBuffer(s.length);
  //     let view = new Uint8Array(buf);
  //     for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
  //     return buf;
  //   }
  //   // saving the written book as a blob
  //   $("#button-a").click(function () {
  //     FILESAVER.saveAs(new Blob([s2ab(workBookOut)], { type: "application/octet-stream" }), 'test.xlsx');
  //   });
  // }
}
